import { logger } from './slardar-utils'

export const DCD_REFERRER = 'dcd_referrer'

export const updateAnchorRel = (node: Node) => {
  if (node.nodeType !== node.ELEMENT_NODE) return
  const anchors = (node as HTMLElement).querySelectorAll('a')
  anchors.forEach((anchor) => {
    const {rel} = anchor
    if (rel.indexOf('noopener') === -1 && rel.indexOf('opener') === -1) {
      anchor.rel = [rel, 'opener'].filter(Boolean).join(' ')
    }
  })
}
export const createRootObserver = () => {
  try {
    const rootNode = document.body
    updateAnchorRel(rootNode)
    const config = { attributes: false, childList: true, subtree: true }
    const callback: MutationCallback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          updateAnchorRel(node)
        })
      }
    }
    const observer = new MutationObserver(callback)
    observer.observe(rootNode, config)
    return observer
  } catch (error) {
    logger.error(
      `[create/root/observer error] message:${(error as Error).message}`
    )
    return null
  }
}

export const setReferrer = () => {
  const docReferrer = document.referrer
  const sessionReferrer = window.sessionStorage.getItem(DCD_REFERRER)
  if (!docReferrer || sessionReferrer) return
  try {
    const referrerURL = new URL(docReferrer)
    window.sessionStorage.setItem(DCD_REFERRER, referrerURL.hostname)
  } catch (error) {
    logger.error(`[set referrer error] message: ${(error as Error).message}`)
  }
}
const META_ARRAY = [
  'baidu',
  'google',
  'sogou',
  'so',
  'bing',
  'lenovo',
  'dongchedi',
]

export const getReferrerMeta = () => {
  const referrer = window.sessionStorage.getItem(DCD_REFERRER)
  if (!referrer) return 'dongchedi'
  const meta = META_ARRAY.find((meta) => referrer.indexOf(meta) !== -1)
  return meta || 'seo'
}
